import React, { useContext, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { heartIcon, orderartLogo } from '../assets/images/_index';
import { AppContext } from '../contexts/AppContext';
import Api from '../helpers/Api';
import useUrl from '../hooks/useUrl';
import { toast } from 'react-toastify';


const Login = () => {
  const [username, setUsername] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [nounce, setNounce] = useState('');
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [askingForOtpVerification, setAskingForOtpVerification] =
    useState(false);
  const appContext = useContext(AppContext);
  const { updateAppContext } = appContext;
  const navigateDom = useNavigate();
  const url = useUrl();

  const tableId = url.get('table_id');
  const isNfcEnabled =
    (localStorage.getItem('is_nfc_enabled') || '0').toString() === '1';

  useQuery(
    ['validateTable', tableId],
    () => Api.get('/tables/validate?table_id=' + tableId),
    {
      onSuccess: data => {
        if (data) {
          updateAppContext({
            ...appContext,
            tableId: tableId,
            logo: data?.data?.logo,
            tableName: data?.data?.table_name
          });
          localStorage.setItem('tableId', tableId);
          localStorage.setItem('tableName', data?.data?.table_name);
          localStorage.setItem('tableOrderingLogo', data?.data?.logo);
          localStorage.setItem('is_nfc_enabled', data?.data?.is_nfc_enabled);
        } else {
          navigateDom('/');
        }
      },
      enabled: !!tableId
    }
  );

  const askForOtpVerification = receivedNounce => {
    setAskingForOtpVerification(true);
    setNounce(receivedNounce);
  };

  const LoginMutation = useMutation(form => Api.post('/users/login', form), {
    onSuccess: json => {
      if (json.data.token) {
        if ('tableOrderingAuthToken' in localStorage) {
          localStorage.removeItem('tableOrderingAuthToken');
          localStorage.removeItem('tableOrderingCartId');
        }
        localStorage.setItem('tableOrderingAuthToken', json.data.token);
        navigateDom('/menu');
      } else if (json.data.nounce) {
        setErrorMessage(json.data.nounce);
      } else {
        setErrorMessage(json.data.otp[0]);
      }
    }
  });

  const RegisterMutation = useMutation(
    form => Api.post('/users/register', form),
    {
      onSuccess: json => {
        const isAlreadyCustomer = json.data.customer;

        isAlreadyCustomer
          ? redirectToMenuByLoggingIn(json.data.nounce)
          : askForOtpVerification(json.data.nounce);
      }
    }
  );

  // Print mutation: posts printnfc request and handles response in onSuccess
  const PrintMutation = useMutation(form => Api.post('/tables/printnfc', form), {
    onSuccess: json => {
      if (!json) {
        toast.error('No response from print API');
        return;
      }

      // If backend returns status in wrapper
      const status = json.status ?? json.res ?? (json?.data?.status ?? null);
      //alert(JSON.stringify(json));
      if (status && status >= 200 && status < 300) {
        toast.success(json?.message || 'Print request sent successfully!');
      } else {
        // show backend message if any
        toast.error(json?.message || 'Print request failed');
        console.error('Print API response', json);
      }
    },
    onError: error => {
      console.error('Print API error', error);
      toast.error('Failed to send print request. Please try again.');
    }
  });

  const redirectToMenuByLoggingIn = nounce => {
    let formData = new FormData();
    formData.append('nounce', nounce);
    formData.append('phone_number', phoneNumber);
    formData.append('table_id', `${tableId}`);

    LoginMutation.mutate(formData);
  };

  const handleSubmit = form => {
    form.preventDefault();
    let formData = new FormData(form.target);

    askingForOtpVerification
      ? LoginMutation.mutate(formData)
      : RegisterMutation.mutate(formData);
  };

  const handlePrint = type => {
    // Prepare and mutate via PrintMutation so onSuccess/onError handlers are used
    const id = localStorage.getItem('tableId') || tableId;
    if (!id) {
      toast.error('Table ID not found');
      return;
    }

    const formData = new FormData();
    formData.append('orderType', type);
    formData.append('table_id', id);

    PrintMutation.mutate(formData);
  };

  return (
    <section>
      <div className="pageBgCol">
        <div className="container mx-w-mobile">
          <div className="row g-0">
            <div className="col-12">
              {isNfcEnabled && (
            <div class="tblCardMain">
            <div class="row g-2">
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("need_service")}>
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1104_1615)">
                      <path d="M32.25 16.5365C31.445 16.5365 30.7917 15.8831 30.7917 15.0781C30.7917 10.9875 29.1992 7.14333 26.3073 4.24999C25.7371 3.67979 25.7371 2.75812 26.3073 2.18791C26.8775 1.6177 27.7992 1.6177 28.3694 2.18791C31.8125 5.63104 33.7083 10.2087 33.7083 15.0781C33.7083 15.8831 33.055 16.5365 32.25 16.5365Z" fill="currentColor"/>
                      <path d="M3.08333 16.5365C2.27833 16.5365 1.625 15.8831 1.625 15.0781C1.625 10.2087 3.52083 5.63104 6.96396 2.18791C7.53417 1.6177 8.45583 1.6177 9.02604 2.18791C9.59625 2.75812 9.59625 3.67979 9.02604 4.24999C6.13417 7.14187 4.54167 10.9875 4.54167 15.0781C4.54167 15.8831 3.88833 16.5365 3.08333 16.5365Z" fill="currentColor"/>
                      <path d="M31.3443 25.3315C29.1393 23.4678 27.8749 20.7436 27.8749 17.8576V13.7917C27.8749 8.65987 24.0628 4.41175 19.1249 3.70008V2.12508C19.1249 1.31862 18.4716 0.666748 17.6666 0.666748C16.8616 0.666748 16.2083 1.31862 16.2083 2.12508V3.70008C11.2689 4.41175 7.45825 8.65987 7.45825 13.7917V17.8576C7.45825 20.7436 6.19388 23.4678 3.97575 25.3432C3.40846 25.8288 3.08325 26.5347 3.08325 27.2813C3.08325 28.6886 4.22804 29.8334 5.63534 29.8334H29.6978C31.1051 29.8334 32.2499 28.6886 32.2499 27.2813C32.2499 26.5347 31.9247 25.8288 31.3443 25.3315Z" fill="currentColor"/>
                      <path d="M17.6666 35.667C20.3077 35.667 22.517 33.7843 23.0245 31.292H12.3087C12.8162 33.7843 15.0256 35.667 17.6666 35.667Z" fill="currentColor"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1104_1615">
                      <rect width="35" height="35" fill="currentColor" transform="translate(0.166626 0.666748)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Need Service</span>
                </div>
              </div>
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("need_water")}>
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1104_1624)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8281 35.6667C20.5841 35.674 22.324 35.3328 23.9471 34.663C25.5703 33.9932 27.0445 33.0081 28.2843 31.7647C30.7583 29.2914 32.0086 26.0983 31.8996 22.5307C31.8006 19.2837 30.5447 15.8787 28.363 12.9426L19.4865 0.997527C19.4102 0.894891 19.3109 0.811527 19.1966 0.754093C19.0823 0.696659 18.9562 0.666748 18.8283 0.666748C18.7004 0.666748 18.5742 0.696659 18.4599 0.754093C18.3457 0.811527 18.2464 0.894891 18.17 0.997527L9.29344 12.9428C7.11134 15.8789 5.85585 19.2839 5.75653 22.5309C5.64784 26.0984 6.89813 29.2916 9.37212 31.7649C10.612 33.0082 12.0861 33.9933 13.7093 34.6631C15.3324 35.3328 17.0723 35.674 18.8281 35.6667ZM21.8645 30.7353C21.7731 30.5379 21.7638 30.3123 21.8386 30.1081C21.9135 29.9038 22.0665 29.7377 22.2638 29.6462C24.6632 28.5332 26.2771 26.3923 26.5808 23.9198C26.5933 23.8123 26.6269 23.7083 26.6797 23.6139C26.7325 23.5194 26.8035 23.4364 26.8885 23.3694C26.9736 23.3025 27.071 23.2531 27.1752 23.224C27.2795 23.195 27.3884 23.1868 27.4958 23.2C27.6032 23.2132 27.707 23.2475 27.801 23.301C27.8951 23.3545 27.9777 23.426 28.044 23.5115C28.1103 23.597 28.159 23.6948 28.1874 23.7993C28.2157 23.9037 28.2231 24.0127 28.2092 24.12C27.8363 27.1587 25.8717 29.781 22.9542 31.1345C22.8565 31.18 22.7507 31.2057 22.643 31.2103C22.5353 31.2148 22.4278 31.1981 22.3266 31.161C22.2253 31.1239 22.1324 31.0672 22.0531 30.9942C21.9739 30.9211 21.9098 30.8331 21.8645 30.7353Z" fill="currentColor"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1104_1624">
                      <rect width="35" height="35" fill="currentColor" transform="translate(0.5 0.666748)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Need Water</span>
                </div>
              </div>
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("read_to_order")}>
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.14217 13.4948C6.19798 15.1281 7.36196 16.6889 8.62631 18.1667H9.57185C9.45269 17.4838 9.28324 16.8106 9.0649 16.1526C8.23006 13.7117 6.77455 11.5301 4.84138 9.82196L5.57529 9.01149C7.64825 10.845 9.20822 13.1866 10.1018 15.8059C10.2461 16.2363 10.3648 16.6776 10.4704 17.1233C10.5196 17.0336 10.5704 16.945 10.6136 16.8498C11.8447 14.1155 11.2464 9.76125 8.63013 8.25079C8.00205 7.9266 7.31475 7.73315 6.60978 7.68211C5.9048 7.63107 5.19681 7.7235 4.52857 7.95383C4.22369 8.03115 3.93794 8.17026 3.68903 8.36254C3.44012 8.55482 3.23335 8.79618 3.08154 9.07164C2.79115 9.805 3.58849 11.0923 5.14217 13.4948Z" fill="currentColor"/>
                      <path d="M17.7532 12.8508C17.7118 12.5208 17.6293 12.1973 17.5076 11.8877C16.655 9.72429 14.1667 8.51843 12.676 8.96249C12.1865 9.12756 11.7642 9.44759 11.4728 9.87413C12.4801 12.0683 12.5942 14.5683 11.7911 16.8452C11.8223 16.8069 11.8595 16.773 11.8901 16.7358C13.0519 15.2334 13.7699 13.4358 13.9628 11.5465L15.0499 11.6657C14.8379 13.76 14.0399 15.7522 12.7476 17.4139C12.5392 17.6775 12.3101 17.9252 12.076 18.1686H14.5982L14.6436 18.1473C14.3568 17.0327 14.5231 15.85 15.106 14.8578C15.6889 13.8655 16.6411 13.1445 17.7542 12.8524L17.7532 12.8508Z" fill="currentColor"/>
                      <path d="M27.7396 18.1666H33.2165C32.8682 17.6619 32.3804 17.2697 31.8127 17.0379C31.4421 16.9129 31.0552 16.8429 30.6643 16.83C30.1623 16.7929 29.593 16.7502 29.3294 16.2236C29.0559 15.6712 29.4294 15.2058 29.7291 14.8312C30.0338 14.5002 30.2565 14.1024 30.3794 13.6697C30.6495 12.4911 30.6528 10.5131 29.5503 9.89294C29.2941 9.76217 29.0142 9.68433 28.7272 9.66403C28.4403 9.64374 28.1522 9.68141 27.8801 9.77481C27.0594 10.0213 26.3625 10.5693 25.9294 11.3088C25.5034 12.1324 25.7523 13.0457 25.9929 13.9278C26.2335 14.8099 26.4851 15.7374 25.8223 16.374C25.149 17.022 24.1658 16.7568 23.2137 16.497C23.2942 17.0546 23.2595 17.6229 23.1119 18.1666H26.6278C26.7645 17.3922 26.9187 16.6168 27.0976 15.8539C27.4038 14.5501 27.7768 13.2453 28.2061 11.976L29.2419 12.326C28.824 13.5625 28.4609 14.834 28.1629 16.1043C28.0032 16.7847 27.8648 17.4759 27.7396 18.1666Z" fill="currentColor"/>
                      <path d="M21.9723 18.1666C22.0726 17.8837 22.1324 17.588 22.15 17.2883L21.2406 17.5913L20.8949 16.5522L22.0335 16.1727C21.8626 15.5781 21.5273 15.0438 21.0662 14.6313C20.6052 14.2188 20.037 13.9448 19.4271 13.8408V14.8854H18.3334V13.8408C17.8102 13.9302 17.3165 14.145 16.8944 14.4668C16.4723 14.7886 16.1344 15.2079 15.9096 15.6887L16.8656 16.0075L16.5199 17.0466L15.616 16.7447C15.6049 16.8538 15.5992 16.9633 15.599 17.0729C15.5983 17.4456 15.6623 17.8157 15.7882 18.1666H21.9723ZM18.3334 15.9791H19.4271V17.0729H18.3334V15.9791Z" fill="currentColor"/>
                      <path d="M7.2061 18.167C6.59433 17.4217 6.00534 16.6532 5.43914 15.8613C4.93932 16.0277 4.45555 16.2389 3.99375 16.4924C3.61873 16.6555 3.31358 16.9461 3.13243 17.3127C3.02088 17.583 2.99121 17.88 3.04711 18.167H7.2061Z" fill="currentColor"/>
                      <path d="M3.0307 19.2607C3.17654 23.0781 4.79446 26.6908 7.54531 29.3415C10.2962 31.9923 13.9663 33.4752 17.7865 33.4795H18.8802C22.7004 33.4752 26.3706 31.9923 29.1214 29.3415C31.8722 26.6908 33.4902 23.0781 33.636 19.2607H3.0307ZM12.0798 30.6904C9.49285 29.4419 7.32347 27.4698 5.83453 25.0133L6.76968 24.4457C8.14928 26.7216 10.159 28.5488 12.5556 29.7061L12.0798 30.6904ZM14.5052 31.292H13.4115V30.1982H14.5052V31.292Z" fill="currentColor"/>
                      <path d="M26.5365 5.04175V3.948H24.349C23.1887 3.948 22.0759 4.40893 21.2554 5.22941C20.4349 6.04988 19.974 7.16268 19.974 8.323V9.41675H22.1615C23.3218 9.41675 24.4346 8.95581 25.2551 8.13534C26.0756 7.31487 26.5365 6.20207 26.5365 5.04175Z" fill="currentColor"/>
                      <path d="M16.1459 6.1355C16.7499 6.1355 17.2396 5.64581 17.2396 5.04175C17.2396 4.43769 16.7499 3.948 16.1459 3.948C15.5418 3.948 15.0521 4.43769 15.0521 5.04175C15.0521 5.64581 15.5418 6.1355 16.1459 6.1355Z" fill="currentColor"/>
                      <path d="M9.0365 4.49487C9.64056 4.49487 10.1302 4.00518 10.1302 3.40112C10.1302 2.79706 9.64056 2.30737 9.0365 2.30737C8.43244 2.30737 7.94275 2.79706 7.94275 3.40112C7.94275 4.00518 8.43244 4.49487 9.0365 4.49487Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <span>Ready to Order</span>
                </div>
              </div>
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("ready_for_main_course")}>
                  <span>
                    <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1104_1639)">
                      <path d="M25.1782 5.8335H9.57166L10.1824 11.0835H18.2499C18.3403 11.0835 18.4307 11.0835 18.5211 11.0911C19.9986 11.1503 21.409 11.7242 22.5082 12.7133C22.7006 12.4244 23.0244 12.2507 23.3715 12.2502H24.4332L25.1782 5.8335Z" fill="currentColor"/>
                      <path d="M25.2499 23.1038V13.417H23.4999V23.0315C23.8849 23.1008 24.2753 23.1369 24.6666 23.1394C24.866 23.1394 25.0568 23.119 25.2499 23.1038Z" fill="currentColor"/>
                      <path d="M16.4999 18.0833V16.7883C16.5003 16.215 16.9649 15.7503 17.5383 15.75H19.4166V14.455C19.417 13.8817 19.8816 13.417 20.4549 13.4167H21.5382C20.6632 12.7064 19.5815 12.2988 18.4552 12.2553C18.3718 12.25 18.3111 12.25 18.2499 12.25H7.74988C4.85185 12.2536 2.50343 14.602 2.49988 17.5V18.0833H16.3756H16.4999ZM8.33333 15.1667H7.75001C7.42784 15.1667 7.1667 14.9055 7.1667 14.5834C7.1667 14.2613 7.42784 14.0001 7.75001 14.0001H8.33333C8.6555 14.0001 8.91664 14.2612 8.91664 14.5834C8.91664 14.9056 8.6555 15.1667 8.33333 15.1667ZM11.8333 16.3333H11.25C10.9278 16.3333 10.6667 16.0722 10.6667 15.75C10.6667 15.4278 10.9278 15.1667 11.25 15.1667H11.8333C12.1555 15.1667 12.4166 15.4278 12.4166 15.75C12.4166 16.0722 12.1555 16.3333 11.8333 16.3333ZM15.3333 15.1667H14.75C14.4278 15.1667 14.1667 14.9055 14.1667 14.5834C14.1667 14.2613 14.4279 14.0001 14.75 14.0001H15.3333C15.6555 14.0001 15.9166 14.2612 15.9166 14.5834C15.9166 14.9056 15.6555 15.1667 15.3333 15.1667Z" fill="currentColor"/>
                      <path d="M20.5834 16.3335V21.4978C21.068 22.0282 21.6663 22.4424 22.3334 22.7094V14.5835H20.5834V16.3335Z" fill="currentColor"/>
                      <path d="M19.4166 19.5752V16.917H17.6666V18.1939C18.4137 18.3968 19.0458 18.8957 19.4166 19.5752Z" fill="currentColor"/>
                      <path d="M26.4167 3.5003C26.4167 3.17813 26.1556 2.91699 25.8334 2.91699H8.91668C8.59451 2.91699 8.33337 3.17813 8.33337 3.5003V4.66699H26.4167V3.5003Z" fill="currentColor"/>
                      <path d="M26.4166 22.9111C27.0522 22.7361 27.647 22.4371 28.1666 22.0315V21.5893V21.5835V14.5835H26.4166V22.9111Z" fill="currentColor"/>
                      <path d="M24.6667 1.16681C24.6667 0.844629 24.4056 0.583496 24.0834 0.583496H10.6667C10.3445 0.583496 10.0834 0.844629 10.0834 1.16681V1.75012H24.6667V1.16681Z" fill="currentColor"/>
                      <path d="M31.0834 18.4241V16.3335H29.3334V20.7242C29.5002 20.4547 29.644 20.1715 29.7633 19.8778C30.0151 19.2508 30.4835 18.735 31.0834 18.4241Z" fill="currentColor"/>
                      <path d="M2.84235 22.5094C2.60036 22.7472 2.47643 23.0801 2.50404 23.4182C2.58416 24.0495 3.12967 24.5174 3.76582 24.5003H8.67519L6.34188 22.167H3.66663C3.35717 22.1662 3.06028 22.2896 2.84235 22.5094Z" fill="currentColor"/>
                      <path d="M15.3437 19.25H4.24988V21H6.34407C6.65237 21.0002 6.94809 21.1225 7.16657 21.3401L10.0833 24.2568L12.9999 21.3401C13.2184 21.1225 13.5141 21.0002 13.8224 21H15.6086L15.3455 19.2832C15.3437 19.2721 15.3455 19.2611 15.3437 19.25Z" fill="currentColor"/>
                      <path d="M14.1666 27.7571L16.4999 30.0904L16.9339 29.6564L16.3249 25.667H4.24988V27.417H13.3441C13.6524 27.4172 13.9481 27.5395 14.1666 27.7571Z" fill="currentColor"/>
                      <path d="M24.3749 30.9169C25.5025 30.9169 26.4166 30.0028 26.4166 28.8752C26.4166 27.7476 25.5025 26.8335 24.3749 26.8335C23.2473 26.8335 22.3333 27.7476 22.3333 28.8752C22.3333 30.0028 23.2473 30.9169 24.3749 30.9169Z" fill="currentColor"/>
                      <path d="M11.4908 24.5003H16.1441L15.7871 22.167H13.8224L11.4908 24.5003Z" fill="currentColor"/>
                      <path d="M34.5833 33.25H30.6651L32.8123 19.25H32.4524C31.7517 19.2455 31.1174 19.6643 30.8465 20.3106C29.8327 22.8492 27.5798 24.3058 24.6632 24.3058C22.7496 24.3753 20.9029 23.5971 19.6162 22.179C19.5903 22.1547 19.5669 22.128 19.5462 22.0991C19.098 21.5642 18.739 20.9605 18.4834 20.3111C18.2125 19.6644 17.578 19.2453 16.8769 19.25H16.5204L18.6636 33.25H17.4842L17.1528 31.0917L16.9125 31.3321C16.6847 31.5598 16.3154 31.5598 16.0877 31.3321L13.3402 28.5834H3.66663H2.49994V30.3334C2.50185 31.9434 3.80656 33.2481 5.41663 33.2501H0.749937C0.427759 33.25 0.166626 33.5112 0.166626 33.8334C0.166626 34.1555 0.427759 34.4167 0.749937 34.4167H34.5832C34.9054 34.4167 35.1666 34.1555 35.1666 33.8334C35.1666 33.5112 34.9055 33.25 34.5833 33.25ZM24.3749 32.0834C22.603 32.0834 21.1666 30.6469 21.1666 28.875C21.1685 27.1039 22.6038 25.6686 24.3749 25.6667C26.1469 25.6667 27.5832 27.1032 27.5832 28.875C27.5832 30.6469 26.1469 32.0834 24.3749 32.0834Z" fill="currentColor"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1104_1639">
                      <rect width="35" height="35" fill="currentColor" transform="translate(0.166626)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Ready for Mains</span>
                </div>
              </div>
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("repeat_drink")}>
                  <span>
                    <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1104_1659)">
                      <path d="M19.0254 1.02539C19.0254 0.459102 18.5663 0 18 0C17.4337 0 16.9746 0.459102 16.9746 1.02539V3.75977C16.9746 4.32605 17.4337 4.78516 18 4.78516C18.5663 4.78516 19.0254 4.32605 19.0254 3.75977V1.02539Z" fill="currentColor"/>
                      <path d="M21.5889 4.64777C22.0793 4.93091 22.7064 4.76289 22.9896 4.27248L24.3568 1.90444C24.6399 1.41403 24.4719 0.7869 23.9815 0.503755C23.4911 0.220611 22.8639 0.388638 22.5808 0.879048L21.2136 3.24709C20.9304 3.7375 21.0985 4.36462 21.5889 4.64777Z" fill="currentColor"/>
                      <path d="M13.0105 4.27248C13.2936 4.76289 13.9207 4.93091 14.4112 4.64777C14.9016 4.36462 15.0696 3.7375 14.7864 3.24709L13.4193 0.879048C13.1361 0.388638 12.509 0.220611 12.0186 0.503755C11.5282 0.7869 11.3601 1.41403 11.6433 1.90444L13.0105 4.27248Z" fill="currentColor"/>
                      <path d="M16.2585 7.81841L6.93346 5.66557C6.45057 5.55407 5.95708 5.80392 5.76103 6.25899L3.73096 10.9717C4.40778 11.5137 5.19679 11.8975 6.05518 12.0957C6.05928 12.0966 6.06338 12.0976 6.06762 12.0985C6.07035 12.0991 6.07302 12.0998 6.07575 12.1004C7.26336 12.3847 8.49116 12.2918 9.62347 11.8315C9.62723 11.83 9.63105 11.8284 9.63481 11.827C11.1395 11.2161 12.7713 11.085 14.3546 11.4478C14.3593 11.4489 14.3643 11.4501 14.3691 11.4512C15.2718 11.6596 16.118 12.0196 16.8804 12.5142L17.0521 8.86574C17.0754 8.37075 16.7413 7.9299 16.2585 7.81841Z" fill="currentColor"/>
                      <path d="M13.8967 13.4469C12.7235 13.1781 11.5145 13.2759 10.4002 13.7297C10.3961 13.7314 10.3919 13.7331 10.3877 13.7347C8.87882 14.3463 7.24619 14.4757 5.66121 14.1097C5.64194 14.1053 5.62266 14.1008 5.60345 14.0961C5.60031 14.0954 5.59689 14.0946 5.59381 14.0939C4.61716 13.8684 3.70702 13.4654 2.89751 12.9067L2.68867 13.3915C1.82974 15.3854 1.89947 17.6401 2.87994 19.5772C3.70429 21.2058 5.09082 22.4483 6.7687 23.093L5.12658 30.2056L1.28485 31.1325C0.8226 31.2441 0.497688 31.6588 0.500012 32.1343C0.502337 32.6098 0.83135 33.0214 1.29469 33.1284L9.28754 34.9737C9.75088 35.0807 10.227 34.855 10.4376 34.4286C10.6482 34.0022 10.5379 33.487 10.1713 33.184L7.12472 30.6668L8.76678 23.5543C10.5575 23.7104 12.3483 23.2015 13.8032 22.099C15.5337 20.7878 16.5847 18.7919 16.6868 16.6232L16.7607 15.0527C15.9813 14.2542 15.0003 13.7016 13.9074 13.4493C13.9039 13.4486 13.9003 13.4477 13.8967 13.4469Z" fill="currentColor"/>
                      <path d="M34.7151 31.1325L30.8734 30.2056L29.2313 23.093C30.9092 22.4483 32.2958 21.2058 33.1201 19.5772C34.1006 17.6401 34.1703 15.3854 33.3114 13.3915L33.1025 12.9067C32.293 13.4653 31.3829 13.8684 30.4062 14.0939C30.4031 14.0946 30.3997 14.0954 30.3966 14.0961C30.3774 14.1007 30.3581 14.1053 30.3388 14.1097C28.7539 14.4757 27.1213 14.3463 25.6123 13.7347C25.6082 13.7331 25.604 13.7314 25.5999 13.7297C24.4856 13.2759 23.2765 13.1781 22.1033 13.4469C22.0997 13.4477 22.0961 13.4486 22.0926 13.4494C20.9997 13.7017 20.0187 14.2542 19.2393 15.0528L19.3132 16.6233C19.4153 18.792 20.4663 20.7879 22.1968 22.0991C23.6517 23.2015 25.4425 23.7104 27.2332 23.5544L28.8753 30.6669L25.8287 33.1841C25.4621 33.487 25.3518 34.0022 25.5624 34.4287C25.773 34.855 26.2491 35.0807 26.7124 34.9738L34.7053 33.1285C35.1686 33.0215 35.4976 32.61 35.5 32.1344C35.5024 31.6588 35.1775 31.2441 34.7151 31.1325Z" fill="currentColor"/>
                      <path d="M21.6455 11.4478C23.2287 11.085 24.8605 11.2161 26.3652 11.827C26.369 11.8285 26.3728 11.83 26.3765 11.8315C27.5088 12.2918 28.7366 12.3847 29.9243 12.1004C29.927 12.0998 29.9297 12.0991 29.9324 12.0985C29.9367 12.0976 29.9407 12.0966 29.9448 12.0957C30.8032 11.8975 31.5922 11.5137 32.269 10.9717L30.239 6.259C30.0429 5.80386 29.5494 5.55408 29.0665 5.66557L19.7415 7.81841C19.2587 7.92991 18.9246 8.37075 18.9479 8.86575L19.1197 12.5142C19.8821 12.0196 20.7282 11.6596 21.631 11.4512C21.6357 11.4501 21.6407 11.4489 21.6455 11.4478Z" fill="currentColor"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1104_1659">
                      <rect width="35" height="35" fill="currentColor" transform="translate(0.5)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Repeat Drinks</span>
                </div>
              </div>
              <div class="col-4">
                <div class="tblCStyle" onClick={() => handlePrint("ready_to_pay")}>
                  <span>
                    <svg width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0477 11.3281C26.3656 11.3281 22.5656 15.1851 22.5656 19.9375C22.5656 24.6899 26.3656 28.5469 31.0477 28.5469C35.7298 28.5469 39.5298 24.6899 39.5298 19.9375C39.5298 15.1851 35.7298 11.3281 31.0477 11.3281ZM27.5745 21.8044L29.3602 23.6169C29.6316 23.8924 30.0031 24.0356 30.3852 24.0138C30.7656 23.9903 31.1209 23.8054 31.3566 23.5009L34.7763 19.1255C35.2352 18.5364 35.137 17.6809 34.5584 17.2151C33.9798 16.7493 33.1352 16.8472 32.6763 17.4362L30.1923 20.6172L29.4691 19.8831C28.9459 19.3521 28.0977 19.3521 27.5745 19.8831C27.0531 20.4124 27.0531 21.2751 27.5745 21.8044Z" fill="currentColor"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.8566 10.4219H1.13696V21.75C1.13696 23.0713 1.65482 24.3401 2.57446 25.2753C3.49589 26.2087 4.74589 26.7344 6.04768 26.7344H23.2655C21.7173 24.9092 20.7798 22.533 20.7798 19.9375C20.7798 15.6999 23.2762 12.0513 26.8566 10.4219ZM13.1923 18.5781H7.83339C7.09411 18.5781 6.49411 19.1871 6.49411 19.9375C6.49411 20.6879 7.09411 21.2969 7.83339 21.2969H13.1923C13.9316 21.2969 14.5316 20.6879 14.5316 19.9375C14.5316 19.1871 13.9316 18.5781 13.1923 18.5781ZM1.13696 7.70312H35.9584V5.4375C35.9584 4.11619 35.4405 2.84744 34.5209 1.91219C33.5995 0.97875 32.3495 0.453125 31.0477 0.453125C24.8637 0.453125 12.2316 0.453125 6.04768 0.453125C4.74589 0.453125 3.49589 0.97875 2.57446 1.91219C1.65482 2.84744 1.13696 4.11619 1.13696 5.4375V7.70312Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <span>Ready to Pay</span>
                </div>
              </div>
            </div>
            </div>
              )}
              <div className="pageInner">
                <div className="titleCol overlayText">
                  <h2>Login to order</h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="table_id"
                    value={`${tableId}`}
                    hidden
                    readOnly
                  />
                  <input
                    type="text"
                    name="nounce"
                    value={nounce}
                    readOnly
                    hidden
                  />
                  <div className="formSection">
                    <div className="formCol">
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        placeholder="Name"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required={!askingForOtpVerification}
                        hidden={askingForOtpVerification}
                      />
                    </div>
                    <div className="formCol">
                      <input
                        type="text"
                        className="form-control"
                        name="phone_number"
                        placeholder="Phone Number"
                        value={phoneNumber}
                        onChange={e => setPhoneNumber(e.target.value)}
                        required={!askingForOtpVerification}
                        hidden={askingForOtpVerification}
                      />
                    </div>
                    <>
                      {askingForOtpVerification ? (
                        <h5>
                          Enter the Verification Code received on your mobile
                          number {phoneNumber}
                        </h5>
                      ) : null}
                    </>
                    <div className="formCol">
                      {errorMessage && (
                        <p className="error"> {errorMessage} </p>
                      )}
                      <input
                        type="text"
                        className="form-control"
                        name="otp"
                        value={otp}
                        onChange={e => setOtp(e.target.value)}
                        placeholder="Verification Code"
                        required={askingForOtpVerification}
                        hidden={!askingForOtpVerification}
                      />
                    </div>
                  </div>
                  <div className="formBtn">
                    <Button
                      type="submit"
                      variant=" btnPrimary"
                      className="btn w-100"
                    >
                      {RegisterMutation.isLoading || LoginMutation.isLoading ? (
                        <Spinner size="sm" className="me-2" />
                      ) : null}
                      {askingForOtpVerification ? 'Verify' : 'Login'}
                    </Button>
                  </div>
                  {errorMessage && (
                    <Button
                      onClick={() => {
                        setAskingForOtpVerification(false);
                        setErrorMessage('');
                        setOtp('');
                      }}
                      variant=" btnPrimary"
                      className="btn mt-3 w-100 py-3"
                    >
                      Enter details again
                    </Button>
                  )}
                </form>
              </div>
              <div className="splashBotmCol">
                <ul>
                  <li>
                    <div className="splashBotomText">
                      <span>
                        Made With
                        <span>
                          <img src={heartIcon} alt="..." />
                        </span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div className="splashBotmLogo">
                      <a href="#!">
                        <img src={orderartLogo} alt="..." />
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
